(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nb-set-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nb-set-builder')) {
 class NBSetBuilder extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   this.form = this.querySelector('form');
   this.button = this.querySelector('button[type="submit"]');
   this.status = this.querySelector('[role="status"]');
   this.selects = [...this.querySelectorAll('select')];
   this.form.addEventListener('change', () => this.update(), {signal:this.controller.signal});
   this.form.addEventListener('submit', e => this.submit(e), {signal:this.controller.signal});
   this.update();
   const signal = this.controller.signal;
   import('@shopify/events').then(({StandardEvents}) => {
    if (signal.aborted) return;
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => {
     if (event.target.closest('product-card')) return;
     event.promise.then(({detail}) => {
      if (!this.isConnected || !detail?.html) return;
      const next = [...detail.html.querySelectorAll('nb-set-builder')].find(el => el.dataset.instance === this.dataset.instance);
      if (next && next.dataset.color !== this.dataset.color) this.replaceWith(next);
     }).catch(() => {});
    }, {signal});
   }).catch(() => {});
  }
  disconnectedCallback() { this.controller?.abort(); }
  update() {
   const total = this.selects.reduce((sum, s) => sum + Number(s.selectedOptions[0]?.dataset.price || s.dataset.defaultPrice), 0);
   this.querySelector('[data-set-total]').textContent = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(total/100)+' '+this.dataset.currency;
  }
  async submit(event) {
   event.preventDefault();
   if (this.busy || !this.form.reportValidity()) return;
   this.busy = true;
   this.button.disabled = true;
   this.form.setAttribute('aria-busy','true');
   this.status.textContent = '';
   let deferred;
   let CartLinesUpdateEvent;
   let submitted = false;
   try {
    ({CartLinesUpdateEvent} = await import('@shopify/events'));
    const items = this.selects.map(s => ({id:Number(s.value),quantity:1}));
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))].slice(0,5);
    deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:items.map(i=>({merchandiseId:String(i.id),quantity:1})),promise:deferred.promise}));
    submitted = true;
    const response = await fetch(this.form.action+'.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections,sections_url:location.pathname})});
    const result = await response.json();
    const cartResponse = await fetch(window.Shopify.routes.root+'cart.js',{headers:{'Accept':'application/json'}});
    if (!cartResponse.ok) throw new Error('cart_refresh');
    const cart = await cartResponse.json();
    const didError = !response.ok || !!result.status;
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:result.sections,source:'nb-set-builder',itemCount:2,didError}});
    this.status.textContent = didError ? (typeof result.description === 'string' ? result.description : this.dataset.error) : this.dataset.success;
    this.querySelector('.nb-set__cart').hidden = false;
    this.busy = false;
    this.button.disabled = false;
   } catch (error) {
    deferred?.reject(error);
    this.status.textContent = submitted ? this.dataset.uncertain : this.dataset.error;
    this.querySelector('.nb-set__cart').hidden = false;
    if (!submitted) { this.busy = false; this.button.disabled = false; }
   } finally {
    this.form.removeAttribute('aria-busy');
   }
  }
 }
 customElements.define('nb-set-builder', NBSetBuilder);
}
  } catch(e) { console.error(e); }
})();

})();
